import Vue from 'vue'
import Vuex from 'vuex'
import { audio } from "./audio"
import api from "@/api/index"
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    allType:[]
  },
  mutations: {
    updateValue(state,{key,value}){
      state[key] = value
    }
  },
  actions: {
    getAllType({state,commit}){
      if(state.allType && state.allType.length){
        return state.allType
      }
      return new Promise((resolve,reject)=>{
        api.userApi.getChannelType().then(res=>{
          commit("updateValue",{key:'allType',value:res.data})
          resolve(res.data)
        })
      })
    }
  },
  modules: {
    audio
  }
})
